import React from 'react';

import { EyeOffOutline, EyeOutline } from '@lyearn/icons';

import useToggle from '../hooks/useToggle';
import Input from '../Input';
import { InputProps } from '../Input/types';
import LinkButton from '../LinkButton';

const InputPassword = React.forwardRef((props: InputProps, ref: any) => {
  const { className, label, ...rest } = props;
  const [showPassword, { toggle }] = useToggle(false);

  return (
    <Input
      ref={ref}
      endAdornment={
        <LinkButton
          Icon={showPassword ? EyeOutline : EyeOffOutline}
          aria-label="toggle password visibility"
          className="py-2 px-4"
          onClick={toggle}
        />
      }
      label={label}
      type={showPassword ? 'text' : 'password'}
      {...rest}
    />
  );
});

export default React.memo(InputPassword);
